import { SAVE_ALL_ROKUB, ACTION_GET_ROKOB_RELATION,ROKOB_SEARCH } from "Stores/actionTypes";
import StatusHandler from "Helpers/StatusHandler";
import RokubService from "Services/http/endpoints/properties/RokubService";
import { read } from "Helpers/LocalStorage";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const GetAllRokub = (params) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.GetAllRokub(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: ((page - 1 ) * limit) + index + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_ROKUB,
          rokubData: updatedData,
          rokubDataPagination:response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditPriceRokub = (data) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.EditPriceRokub(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditRokub = (data) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.EditRokub(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Rokub_editing_was_done_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertRokubData = (data) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.InsertRokubData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('New_Roku_was_registered_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteRokub = (data) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.deleteRokub(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_tracking_was_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationRokob(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableRokub = (data) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.disableRokub(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Rocube_has_been_successfully_disabled'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationRokob = (params) => {
  return async (dispatch) => {
    try {
      const response = await RokubService.getRelationRokob(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_ROKOB_RELATION,
          dataRelationRokob: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeRokubSearch = (rokubDataSearch) => (dispatch) => {
  dispatch({
    type: ROKOB_SEARCH,
    rokubDataSearch: rokubDataSearch,
  });
};